var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { system } from "styled-system";
import { Box } from "./Box";
export var Text = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  ", "\n  ", "\n"])), function (_a) {
    var isStrikethrough = _a.isStrikethrough, theme = _a.theme;
    if (isStrikethrough) {
        return {
            textDecoration: "line-through ".concat(theme.colors.text, " solid")
        };
    }
}, system({
    wordBreak: true,
    textTransform: true
}));
var templateObject_1;
//# sourceMappingURL=Text.js.map